
import React, { Component } from 'react'
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import { actions as employeeActions } from '../../../actions/employee'
import UnacceptedStockAward from './UnacceptedStockAward'
import AcceptAwardWizard from '../AcceptAwardWizard'
import employeeService from '../../../services/Employee.service'

const Wrapper = styled.div`
background-color: #eaeaea;
`

const Container = styled.section`

  // Desktop version.
  @media (min-width: 768px) {
    width: 930px;
    padding: 24px 0 24px 0;
    margin: 0 auto;
      
    .award-table {
      display: table;
      width: 100%;
    }
  }

  // Mobile version.
  @media (max-width: 768px) {
    padding: 24px 16px 24px 16px;
  }

  > h2 {
    font-family: Lato-Light;
    font-size: 24px;
    font-weight: normal;
    
    color: #2B2B2B;
    line-height: 28px;
    padding: 0;
    margin: 0;
  }

  > p {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;

    // Desktop version.
    @media (min-width: 768px) {
      line-height: 22px;
    }

    // Mobile version.
    @media (max-width: 768px) {
      line-height: 17px;
    }
  }
`

export class UnacceptedStockAwards extends Component {
  state = {
    wizardVisible: false,
  }

  buttonClickHandler = (award, callback) => {
      this.setState({
        wizardVisible: true,
        award: award
      })
  }

  onWizardClosed = () => {
    // Close the wizard.
    this.setState({wizardVisible: false})
  }

  render() {
    const { t, unnacepted_awards } = this.props;
    if(!(unnacepted_awards && unnacepted_awards.length > 0)) {
      return null
    }

    return (
      <Wrapper>
        <Container className="unaccepted-awards-container" aria-labelledby="unacceptedAwardsHeading">
          <h2 id="unacceptedAwardsHeading">{t('UnacceptedStockAwards.Title')}</h2>
          {unnacepted_awards && unnacepted_awards.length > 0 &&
            <p>{t('UnacceptedStockAwards.SubTitle')}</p>
          }
          
          {unnacepted_awards && unnacepted_awards.length > 0 &&
            <div className="award-table">
              {unnacepted_awards.map((el) => {
              return <UnacceptedStockAward
                onClick={this.buttonClickHandler}
                key={`unnacepted_award_${el.id}`}
                award={el}/>
              })}
            </div>
          }

          {!(unnacepted_awards && unnacepted_awards.length > 0) &&
            <p>{t('UnacceptedStockAwards.NoAwardsMessage')}</p>
          }

          <AcceptAwardWizard 
            visible={this.state.wizardVisible}
            award={this.state.award} 
            broker={this.props.broker} 
            onWizardClosed={this.onWizardClosed}
            />

        </Container>
      </Wrapper>
    )
  }
}

const mapState = state => ({
  unnacepted_awards: employeeService.getUnnaceptedRSUs(state.employee.awards),
  broker: state.employee.broker == null ? '' : state.employee.broker.name
});

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
  }
})

export default connect(mapState, mapDispatchToProps)(withTranslation("translations")(UnacceptedStockAwards));


